import { Box, Container, Grid } from '@mui/material';
import { linear_content_style, linear_item, linear_v } from '../../../libs/linear-layout/LinearLayout';
import Label from '../../../libs/rhf-mui/ui/Label';
import { UniFunc } from '../../dao/UniFunc';
import { SpwkToHisInfo } from './SpwkToHisInfo';

type Props = {
  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;
}

const UcHisBasicView = ({ CurrInfo, CurrUniFunc, ...props }: Props) => {

  let data_list = CurrInfo?.ExportBundle?.AllHisBasicList ?? [];
  if (CurrUniFunc != null) {
    data_list = data_list.filter(x => x.作業編號 === CurrUniFunc.func_code);
  }

  const json = JSON.stringify(data_list, null, 4);

  return (
    <Grid {...linear_v}>
      <Grid {...linear_item}>
        <Container >
        </Container>
      </Grid>
      <Grid {...linear_item} flex={1} sx={{}}>
        <Box style={linear_content_style}>
          <Container >
            <Label>{json}</Label>
          </Container>
        </Box>
      </Grid>
    </Grid>
  )
}

export default UcHisBasicView